var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 31 31",
    enableBackground: "new 0 0 31 31",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#178FEB",
    d: "M28.7,26.3L22.5,20c1.6-2.2,2.5-4.8,2.5-7.5C25,5.6,19.4,0,12.5,0S0,5.6,0,12.5S5.6,25,12.5,25 c2.2,0,4.4-0.6,6.3-1.7l6.4,6.4l0.7,0.7l0.7-0.7l2-2l0.7-0.7L28.7,26.3z M12.5,20C8.4,20,5,16.6,5,12.5S8.4,5,12.5,5S20,8.4,20,12.5 S16.6,20,12.5,20z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.24169d168d3c56931cad91dd3e914ec0.svg";
export { ForwardRef as ReactComponent };